export default __webpack_public_path__ + "static/media/First stage regulator.482bd8ef.jpeg";